import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Clock } from "lucide-react";

interface TimingPreferencesProps {
  preferences?: {
    hoursBeforeSunrise?: number | null;
    hoursBeforeSunset?: number | null;
  } | null;
  onUpdate: (updates: Record<string, number>) => void;
}

export function TimingPreferences({ preferences, onUpdate }: TimingPreferencesProps) {
  return (
    <Card className="card-elevated border-none shadow-premium">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Clock className="h-5 w-5" />
          Timing Preferences
        </CardTitle>
        <CardDescription>
          Control when you receive notifications before sunrise and sunset events
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <Label htmlFor="hours-before-sunrise">
              <p className="font-medium">Hours before sunrise</p>
              <p className="text-sm text-muted-foreground">
                Get notified this many hours before sunrise
              </p>
            </Label>
            <span className="text-lg font-semibold tabular-nums">
              {preferences?.hoursBeforeSunrise ?? 2}h
            </span>
          </div>
          <Slider
            id="hours-before-sunrise"
            min={1}
            max={12}
            step={1}
            value={[preferences?.hoursBeforeSunrise ?? 2]}
            onValueChange={([value]) => onUpdate({ hoursBeforeSunrise: value })}
            className="w-full"
          />
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <Label htmlFor="hours-before-sunset">
              <p className="font-medium">Hours before sunset</p>
              <p className="text-sm text-muted-foreground">
                Get notified this many hours before sunset
              </p>
            </Label>
            <span className="text-lg font-semibold tabular-nums">
              {preferences?.hoursBeforeSunset ?? 2}h
            </span>
          </div>
          <Slider
            id="hours-before-sunset"
            min={1}
            max={12}
            step={1}
            value={[preferences?.hoursBeforeSunset ?? 2]}
            onValueChange={([value]) => onUpdate({ hoursBeforeSunset: value })}
            className="w-full"
          />
        </div>
      </CardContent>
    </Card>
  );
}
